import type { NextRouter } from 'next/router';
import type React from 'react';

import { useEffect, useRef } from 'react';

import { 
  setMathJaxPageAttributes,
  trackMathJaxRerendering 
} from '../../../utils/newrelic-mathjax';
import { getFormulaCount } from '../utils';

export const useRouteChangeHandler = (
  router: NextRouter,
  rerenderMath: (_targetElements?: Element[]) => Promise<void>,
  isInitialized: React.MutableRefObject<boolean>
) => {
  const prevConceptIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const currentConceptId = router.query.conceptId as string | undefined;
    
    if (currentConceptId && currentConceptId !== prevConceptIdRef.current) {
      prevConceptIdRef.current = currentConceptId;
      
      const formulaCount = getFormulaCount();
      setMathJaxPageAttributes(currentConceptId, formulaCount);

      setTimeout(() => {
        if (window.MathJax?.typesetPromise) {
          if (window.MathJax.startup?.promise) {
            window.MathJax.startup.promise.then(() => {
              rerenderMath().catch((error: Error) => {
                trackMathJaxRerendering.failure(error);
              });
            });
          } else {
            rerenderMath().catch((error: Error) => {
              trackMathJaxRerendering.failure(error);
            });
          }
        } else {
          window.dispatchEvent(new CustomEvent('mathjax-rerender-needed'));
        }
      }, 500);
    } else if (!currentConceptId) {
      prevConceptIdRef.current = undefined;
    }
  }, [router.query.conceptId, rerenderMath, isInitialized]);
};